import { useSweepstakes } from '../../contexts/SweepstakesContext'
import { DollarSign, Star, Camera } from 'lucide-react'
import Button from '../ui/Button'

/**
 * Step1PriorityChoice
 * First step: Ask what matters most when choosing a photographer
 */
const Step1PriorityChoice = () => {
  const { formData, updateFormData, goToNextStep, errors } = useSweepstakes()

  const handleSelect = (choice) => {
    updateFormData('priorityChoice', choice)
  }

  const handleNext = () => {
    goToNextStep()
  }

  const options = [
    {
      value: 'affordable_pricing',
      label: 'Affordable pricing',
      icon: DollarSign,
      description: 'Budget-friendly options that fit your needs'
    },
    {
      value: 'great_reviews',
      label: 'Great reviews',
      icon: Star,
      description: 'Trusted by couples just like you'
    },
    {
      value: 'beautiful_portfolio',
      label: 'Beautiful portfolio',
      icon: Camera,
      description: 'Stunning work that speaks for itself'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Question */}
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          What matters most to you when choosing a wedding photographer?
        </h3>
        <p className="text-sm text-gray-600">
          This helps us understand what's important to you
        </p>
      </div>

      {/* Options */}
      <div className="space-y-3">
        {options.map((option) => {
          const Icon = option.icon
          const isSelected = formData.priorityChoice === option.value

          return (
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={`
                w-full p-4 rounded-lg border-2 transition-all text-left
                ${isSelected
                  ? 'border-purple-600 bg-purple-50 shadow-md'
                  : 'border-gray-200 hover:border-purple-300 hover:bg-purple-50/50'
                }
              `}
            >
              <div className="flex items-start">
                <div className={`
                  flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center
                  ${isSelected ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-600'}
                `}>
                  <Icon className="w-5 h-5" />
                </div>
                <div className="ml-3 flex-1">
                  <div className="flex items-center">
                    <span className={`font-semibold ${isSelected ? 'text-purple-900' : 'text-gray-900'}`}>
                      {option.label}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    {option.description}
                  </p>
                </div>
                {/* Radio indicator */}
                <div className={`
                  flex-shrink-0 w-5 h-5 rounded-full border-2 ml-2
                  ${isSelected ? 'border-purple-600 bg-purple-600' : 'border-gray-300'}
                  flex items-center justify-center
                `}>
                  {isSelected && (
                    <div className="w-2 h-2 bg-white rounded-full" />
                  )}
                </div>
              </div>
            </button>
          )
        })}
      </div>

      {/* Error Message */}
      {errors.priorityChoice && (
        <p className="text-sm text-red-600 text-center">
          {errors.priorityChoice}
        </p>
      )}

      {/* Next Button */}
      <div className="pt-4">
        <Button
          onClick={handleNext}
          className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors"
          disabled={!formData.priorityChoice}
        >
          Continue
        </Button>
      </div>
    </div>
  )
}

export default Step1PriorityChoice
